module.exports = __webpack_public_path__ + "img/avatar.306b894c.jpeg";